import {video_schema} from './videoSchema'
import {isVideo} from './videoSchema'
import {pauseAllVideo} from './video'


export function openLink(link) {
  // console.log(isVideo(link))
  if(!link){
    return;
  }
  pauseAllVideo(); //跳链之前先暂停视频，为了MgtvApi.jumpPage或者schema打开后，视频仍然在播放的问题

  if (isVideo(link)) {
    let schema = link;
    if (gact.is_app) {
      if (gact.is_ipad) {
        schema = video_schema(link, 'pad')
      } else {
        schema = video_schema(link, 'mobile')
      }
    }
    console.log('跳转到视频', schema);
    window.location.href = schema;
  } else {
    if (window.gact.is_h5) {
      window.location.href = link;
    } else {
      console.log('app打开', link)
      MgtvApi.jumpPage({
        url: link
      });
    }
  }
}


export function openSchema(schema){
  if(!schema){
    return;
  }
  if (gact.is_wx) {
    window.location.href = `https://a.app.qq.com/o/simple.jsp?pkgname=com.hunantv.imgo.activity&ios_scheme=${encodeURIComponent(schema)}&android_schema=${encodeURIComponent(schema)}&ckey=CK1393171797859`
  } else {
    window.location.href = schema;
  }
}



// WEBPACK FOOTER //
// ./src/tools/mgtv/link.js